export default __webpack_public_path__ + "static/media/advanced_search_opened.c9dd24b0.svg";